import ReportItemBase from "./Components/ReportItemBase";

export default ReportItemBase;
